export default "/arrow.e6fed5e3-3c6dc7.svg";